export default __webpack_public_path__ + "static/img-credit-score-old-vs-new-d6d32d6428f3555de41603e9048314a4.webp";